'use client';

import cx from 'classnames';

import { useCopy } from '@flipster/features/src/shared/webview/clipboard';
import { Button } from '@flipster/ui';
import ShareIcon from '@flipster/ui/assets/svgs/share.svg';

import { FlipsterUrl } from '@web/constants/metadata';

import { GlossaryTermPageGlossaryTermFragment } from '../query.generated';
import styles from './index.module.scss';

const ShareTermButton = ({
  className,
  glossaryTerm,
}: {
  className?: string;
  glossaryTerm: GlossaryTermPageGlossaryTermFragment;
}) => {
  const copy = useCopy('Glossary link copied');
  const url = `${FlipsterUrl}/glossary/${glossaryTerm.slug}`;

  const onClickShareTermButton = () => {
    if (navigator.share) {
      navigator.share({ title: document.title, url });
    } else {
      copy(url);
    }
  };

  return (
    <Button
      shape='tertiary'
      onClick={onClickShareTermButton}
      className={cx(styles.button, className)}
      aria-label='Copy the term link to the clipboard'
      size='medium'
    >
      <ShareIcon className={styles.icon} />
      Share
    </Button>
  );
};

export default ShareTermButton;
